class ScoreSuffix {
    getScoreSuffix(score) {
        var lastDigit = score.toString().split('').pop();

        if (lastDigit === '1' && score !== 11) {
            return 'st';
        }
        if (lastDigit === '2' && score !== 12) {
            return 'nd';
        }
        if (lastDigit === '3' && score !== 13) {
            return 'rd';
        }
        return 'th';
    }
}

export default ScoreSuffix;



// WEBPACK FOOTER //
// ./src/components/elimination-end/scoreSuffix.js